import './App.css';
import React, { useState, useEffect } from 'react';
import logoTauro from './assets/logo.jpg';
import fachadaTauro from './assets/fachada.jpg';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [nombre, setNombre] = useState("");
  const [categoria, setCategoria] = useState("");
  const [pedido, setPedido] = useState("");
  const [isSent, setIsSent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const enviarWhatsApp = () => {
    if (!nombre || !pedido || !categoria) {
      alert("Por favor, completa los campos.");
      return;
    }
    const num = "522281130175";
    const mensaje = `*Ferretería TAURO* 🐂\n\n*Cliente:* ${nombre}\n*Categoría:* ${categoria}\n*Pedido:* ${pedido}`;
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(mensaje)}`, '_blank');
    setIsSent(true);
  };

  return (
    <div className="App">
      {/* HEADER */}
      <header className={`navbar-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-left"><img src={logoTauro} className="logo-img-nav" alt="Logo" /></div>
        <h1 className="brand-title">FERRETERÍA Y MATERIALES "TAURO"</h1>
        <div className="header-right"><a href="#cotizar" className="btn-contacto">CONTACTO</a></div>
      </header>

      {/* HERO SECTION */}
      <section className="hero">
        <img src={fachadaTauro} className="hero-bg" alt="Fachada" />
        <div className="hero-content">
          <p className="hero-slogan">"Nos Ocupamos de lo que a ti te preocupa..."</p>
          <h2 className="hero-main-subtitle">Soluciones para tu construcción</h2>
          <a href="#cotizar" className="btn-incitante">¡HAZ TU PEDIDO AQUÍ!</a>
        </div>
      </section>

      {/* SECCIÓN COTIZACIÓN */}
      <section id="cotizar" className="cotizacion-section">
        <div className="form-container">
          {!isSent ? (
            <div className="form-card">
              <h2 className="form-title">Cotización Rápida 📝</h2>
              <div className="form-body">
                <label>¿Cómo te llamas?</label>
                <input type="text" placeholder="Tu nombre" className="input-field" onChange={(e) => setNombre(e.target.value)} />
                
                <label>Selecciona un área</label>
                <div className="category-grid">
                  {['Obra Negra', 'Ferretería', 'Plomería', 'Eléctrico'].map((cat) => (
                    <button key={cat} onClick={() => setCategoria(cat)} className={`cat-btn ${categoria === cat ? 'active' : ''}`}>{cat}</button>
                  ))}
                </div>

                <label>Tu lista de materiales</label>
                <textarea placeholder="Ej: 10 bultos de cemento..." className="textarea-field" onChange={(e) => setPedido(e.target.value)}></textarea>

                <button onClick={enviarWhatsApp} className={`btn-whatsapp-final ${nombre && pedido && categoria ? 'ready' : ''}`}>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WA" />
                  ENVIAR A WHATSAPP
                </button>
              </div>
            </div>
          ) : (
            <div className="success-view">
               <div className="coupon-card">
                  <h2>¡LISTO! ✅</h2>
                  <p>Tu pedido ha sido enviado.</p>
                  <div className="coupon-box">TAURO-5%</div>
                  <button onClick={() => setIsSent(false)} className="btn-reset">Nuevo Pedido</button>
               </div>
            </div>
          )}
        </div>
      </section>
      
      {/* SECCIÓN DE UBICACIÓN PERSUASIVA */}
      <section className="location-section-premium">
        <div className="location-container">
          <div className="location-card">
            <div className="location-icon-circle">
              <span className="geo-icon">📍</span>
            </div>
            <h3 className="location-title-premium">VISÍTANOS EN TIENDA</h3>
            <div className="address-details">
              <p className="main-street">Calle Amatista 103</p>
              <p className="sub-address">Fracc. Bugambilias, Emiliano Zapata</p>
              <p className="zip-code">Veracruz | CP 91637</p>
            </div>
            
            {/* ENLACE DE NAVEGACIÓN DIRECTA CON COORDENADAS */}
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=19.49605037318523,-96.85185244874936" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-gps-premium"
            >
              <span className="gps-icon">🚗</span>
              ¡INICIAR RUTA POR GPS!
            </a>
          </div>
        </div>

        <div className="map-frame-container">
          {/* MAPA CONFIGURADO CON MARCADOR EN LAS COORDENADAS EXACTAS */}
          <iframe 
            title="mapa-tauro"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d470.2173516518711!2d-96.851852!3d19.49605!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDI5JzQ1LjgiTiA5NsKwNTEnMDYuNyJX!5e0!3m2!1ses-419!2smx!4v1715600000000!5m2!1ses-419!2smx" 
            width="100%" 
            height="450" 
            style={{border:0}} 
            allowFullScreen="" 
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade">
          </iframe>
        </div>

        {/* REDES SOCIALES (Mantiene tu estructura anterior) */}
        <div className="social-industrial-bar">
          <p className="social-text">SÍGUENOS EN NUESTRAS REDES</p>
          <div className="social-grid">
            <a href="https://www.facebook.com/share/1BFR7Yz9PW/?mibextid=wwXIfr" className="social-card fb" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/b/b9/2023_Facebook_icon.svg" alt="FB" /> Facebook
            </a>
            <a href="https://www.instagram.com/ferreteriatauroficial?igsh=MWpldG91eWRsZ29kMw==" className="social-card ig" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg" alt="IG" /> Instagram
            </a>
            <a href="https://wa.me/522281130175" className="social-card wa" target="_blank" rel="noopener noreferrer">
              <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WA" /> WhatsApp
            </a>
          </div>
        </div>
      </section>

        

      <footer className="main-footer">
        <p>Ferretería y Materiales TAURO 🐂 | {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

export default App;